var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 .75C11.16.75.75 11.16.75 24S11.16 47.25 24 47.25 47.25 36.84 47.25 24 36.84.75 24 .75zm12.198 11.052c6.135 6.136 6.562 15.514 1.938 22.091L14.106 9.864c6.582-4.627 15.96-4.194 22.092 1.938zM11.802 36.198C5.667 30.062 5.24 20.684 9.864 14.107l24.03 24.029c-6.582 4.627-15.96 4.194-22.092-1.938z",
    id: "3cofvw4m0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBan);
export default __webpack_public_path__ + "static/media/ban.a88f950a4fcae50534c8bb46e5602f22.svg";
export { ForwardRef as ReactComponent };